var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pc-dashboard__text pc-section-dashboard-intro-style-2"},[_c('text-body-extra-small',{staticClass:"pc-dashboard__text-description",domProps:{"innerHTML":_vm._s(_vm.currentText)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }